import { render, staticRenderFns } from "./batchNo.vue?vue&type=template&id=32543d84&scoped=true"
import script from "./batchNo.vue?vue&type=script&lang=js"
export * from "./batchNo.vue?vue&type=script&lang=js"
import style0 from "./batchNo.vue?vue&type=style&index=0&id=32543d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32543d84",
  null
  
)

export default component.exports